module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/bad/clear_items-0653bf792c9b0add74b48fd0dfe4a18c.png";